import type { TranslationEntity } from "./TranslationEntity";

export class DisableBranchEntity {
    id?: number;
    translations?: Array<TranslationEntity> | null;
}
